import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import jsonp from "../../../assets/js/http";
@Component
export default class slipBlock extends Vue{
  bgImage: string = ''
  slipImage: string = ''
  y: any = 0
  x: any = 0
  btnLeft: any = 0
  startX: any = 0
  moveCount: any = 0
  startTime: any = 0
  mouseoverInfo: string = ''
  useTime: any = ''
  key: string = ''
  
  // 设置图片数据
  setImageData (data: any) {
    this.bgImage = `data:image/jpg;base64,${data.shadeImage}`
    this.slipImage = `data:image/png;base64,${data.cutoutImage}`
    this.y = data.y
    this.x = data.x
    this.btnLeft = 0
    this.key = data.key
  }

  getImage () {
    jsonp(`https://m${process.env.VUE_APP_URI_DOMAIN}/mthirdparty/psbc/getCodeImage`, {
      jsoncallback: 'getImage',
    }).then((res: any) => {
      if (res.code == '0000') {
        this.setImageData(res)
      }
    })
  }

  startEvent(e: any) {
    this.startTime = new Date().valueOf()
    this.startX = (e.clientX || e.touches[0].clientX) - 26
  }

  moveEvent (e: any) {
    e.preventDefault()
    let moveX = (e.clientX || e.touches[0].clientX) - this.startX
    this.leftX(moveX)
    if (this.moveCount % 10 == 0) {
      const timeDiff = ((new Date()).valueOf()) - this.startTime;
      this.mouseoverInfo += (parseInt(this.x) + "|" + this.y + "|" + timeDiff + ",");
    }
    this.moveCount++
    let domX = 225
    if (this.x <= 0) {
      this.leftX(0)
    } else if (this.x > domX) {
      this.leftX(domX)
    }
  }

  endEvent (e:any) {
    this.useTime = (new Date().valueOf()) - this.startTime
    // 验证
    this.validateRandomCode()
  }

  leftX (x:any) {
    this.x = x
    this.btnLeft = x
  }

  validateRandomCode () {
    let params = {
      x: this.x,
      y: this.y,
      useTime: this.useTime,
      mouseoverInfo: this.mouseoverInfo,
      key: this.key,
      jsoncallback: 'validateRandomCode'
    }
    jsonp(`https://m${process.env.VUE_APP_URI_DOMAIN}/mthirdparty/psbc/validateRandomCode`, params)
    .then((res: any) => {
      if (res) {
        this.$emit('callbackEvent', res)
      } else {
        this.closeBlock()
      }
    }, (err: any) => {
      this.$toast(err.msg || err.returnMessage || err.message)
      this.closeBlock()
    })
  }

  closeBlock () {
    this.$emit('closeBlock')
  }

  mounted() {
    this.getImage()
  }
}
